module.exports = __webpack_public_path__ + "img/arrow-right.158283ed.svg";